
export const getSelectedLanguage = state => state.app.language;

export const getTitle = state => state.app.title;

export const getMessages = state => state.app.messages;

export const getConfig = state => state.app.config;

export const getMaxFileSize = state => state.app.uploads;

export const shouldForceLogin = state => state.app.config.APP_FORCE_LOGIN === 'Enabled';

export const isLoading = state => {
  const value = Object.keys(state.app.requests).reduce((result, key) => {
    if (result) {
      return result;
    }
    return !!state.app.requests[key];
  }, false)
  return value;
};
